var map = {
	"./aboutus-banner.jpg": "./src/assets/project_images/pic/aboutus-banner.jpg",
	"./intex-banner.jpg": "./src/assets/project_images/pic/intex-banner.jpg",
	"./organizers-banner.jpg": "./src/assets/project_images/pic/organizers-banner.jpg",
	"./press-banner.jpg": "./src/assets/project_images/pic/press-banner.jpg",
	"./visitors-banner.jpg": "./src/assets/project_images/pic/visitors-banner.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/project_images/pic sync recursive ^\\.\\/.*\\-banner\\.jpg$";